var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "list-form" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _c(
          "el-form",
          {
            ref: "form",
            staticClass: "form",
            attrs: {
              inline: true,
              model: _vm.form,
              rules: _vm.rules,
              size: "small",
              "label-width": "96px",
            },
          },
          [
            _c("div", { staticClass: "text" }, [_vm._v("班次基本信息")]),
            _c(
              "div",
              { staticClass: "form-row" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "班次名称", prop: "name" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "300px" },
                      attrs: {
                        placeholder: "请输入班次名称",
                        maxlength: "12",
                        clearable: "",
                        "show-word-limit": "",
                      },
                      model: {
                        value: _vm.form.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "name", $$v)
                        },
                        expression: "form.name",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "text" }, [_vm._v("上班打卡时间范围")]),
            _c(
              "div",
              { staticClass: "form-row" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "上班时间", prop: "startTime" } },
                  [
                    _c("el-time-picker", {
                      staticClass: "time-picker",
                      attrs: {
                        "default-value": new Date(2026, 1, 1, 0, 0, 0),
                        format: "HH:mm",
                        "value-format": "HH:mm:ss",
                        placeholder: "请选择上班时间",
                      },
                      on: { change: _vm.changeStartTime },
                      model: {
                        value: _vm.form.startTime,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "startTime", $$v)
                        },
                        expression: "form.startTime",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "上班前", prop: "startTime1" } },
                  [
                    _vm.form.startTime
                      ? _c("el-time-picker", {
                          staticClass: "time-picker time-picker-none-prefix",
                          attrs: {
                            "default-value": new Date(2026, 1, 1, 0, 0, 0),
                            format: "HH小时mm分",
                            "value-format": "HH:mm",
                            "picker-options": {
                              selectableRange: "00:00:00 - 12:00:00",
                            },
                            placeholder: "请选择上班前时间",
                          },
                          model: {
                            value: _vm.form.startTime1,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "startTime1", $$v)
                            },
                            expression: "form.startTime1",
                          },
                        })
                      : _c("el-input", {
                          attrs: {
                            placeholder: "请选择上班前时间",
                            readonly: "",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.chekTime("startTime", "startTime1")
                            },
                          },
                        }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "上班后", prop: "startTime2" } },
                  [
                    _vm.form.startTime
                      ? _c("el-time-picker", {
                          staticClass: "time-picker time-picker-none-prefix",
                          attrs: {
                            "default-value": new Date(2026, 1, 1, 0, 0, 0),
                            format: "HH小时mm分",
                            "value-format": "HH:mm",
                            "picker-options": {
                              selectableRange: "00:00:00 - 12:00:00",
                            },
                            placeholder: "请选择上班后时间",
                          },
                          model: {
                            value: _vm.form.startTime2,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "startTime2", $$v)
                            },
                            expression: "form.startTime2",
                          },
                        })
                      : _c("el-input", {
                          attrs: {
                            placeholder: "请选择上班后时间",
                            readonly: "",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.chekTime("startTime", "startTime2")
                            },
                          },
                        }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "text" }, [_vm._v("下班打卡时间范围")]),
            _c(
              "div",
              { staticClass: "form-row" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "下班时间", prop: "endTime" } },
                  [
                    _vm.form.startTime
                      ? _c("el-time-picker", {
                          staticClass: "time-picker",
                          attrs: {
                            "picker-options": _vm.endTimePickerOptions,
                            "default-value": new Date(2026, 1, 1, 0, 0, 0),
                            format: "HH:mm",
                            "value-format": "HH:mm:ss",
                            placeholder: "请选择下班时间",
                          },
                          on: { change: _vm.changeEndTime },
                          model: {
                            value: _vm.form.endTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "endTime", $$v)
                            },
                            expression: "form.endTime",
                          },
                        })
                      : _c("el-input", {
                          attrs: {
                            placeholder: "请选择下班时间",
                            "prefix-icon": "el-icon-time",
                            readonly: "",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.chekTime("startTime", "endTime")
                            },
                          },
                        }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "下班前", prop: "endTime1" } },
                  [
                    _vm.form.endTime
                      ? _c("el-time-picker", {
                          staticClass: "time-picker time-picker-none-prefix",
                          attrs: {
                            "default-value": new Date(2026, 1, 1, 0, 0, 0),
                            format: "HH小时mm分",
                            "value-format": "HH:mm",
                            "picker-options": {
                              selectableRange: "00:00:00 - 12:00:00",
                            },
                            placeholder: "请选择下班前时间",
                          },
                          model: {
                            value: _vm.form.endTime1,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "endTime1", $$v)
                            },
                            expression: "form.endTime1",
                          },
                        })
                      : _c("el-input", {
                          attrs: {
                            placeholder: "请选择下班前时间",
                            readonly: "",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.chekTime("endTime", "endTime1")
                            },
                          },
                        }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "下班后", prop: "endTime2" } },
                  [
                    _vm.form.endTime
                      ? _c("el-time-picker", {
                          staticClass: "time-picker time-picker-none-prefix",
                          attrs: {
                            "default-value": new Date(2026, 1, 1, 0, 0, 0),
                            format: "HH小时mm分",
                            "value-format": "HH:mm",
                            "picker-options": _vm.clockOutAfterPickerOptions,
                            placeholder: "请选择下班后时间",
                          },
                          on: { change: _vm.changeEndTime2 },
                          model: {
                            value: _vm.form.endTime2,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "endTime2", $$v)
                            },
                            expression: "form.endTime2",
                          },
                        })
                      : _c("el-input", {
                          attrs: {
                            placeholder: "请选择下班后时间",
                            readonly: "",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.chekTime("endTime", "endTime2")
                            },
                          },
                        }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "text" }, [_vm._v("休息时间")]),
            _c(
              "div",
              { staticClass: "form-row" },
              [
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "300px" },
                    attrs: { label: " ", "label-width": "24px" },
                  },
                  [
                    _c(
                      "el-checkbox",
                      {
                        on: { change: _vm.changeRestTime },
                        model: {
                          value: _vm.form.restTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "restTime", $$v)
                          },
                          expression: "form.restTime",
                        },
                      },
                      [_vm._v("休息时间")]
                    ),
                  ],
                  1
                ),
                _vm.form.restTime
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "休息时间", prop: "restTimeRange" } },
                      [
                        _vm.form.startTime && _vm.form.endTime
                          ? _c("el-time-picker", {
                              attrs: {
                                "is-range": "",
                                "picker-options": {
                                  selectableRange: "00:00:00 - 23:59:59",
                                },
                                format: "HH:mm",
                                "value-format": "HH:mm:ss",
                                "range-separator": "至",
                                "start-placeholder": "休息开始",
                                "end-placeholder": "休息结束",
                                placeholder: "选择时间范围",
                              },
                              on: { change: _vm.changeRestTimeRange },
                              model: {
                                value: _vm.form.restTimeRange,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "restTimeRange", $$v)
                                },
                                expression: "form.restTimeRange",
                              },
                            })
                          : _c(
                              "div",
                              {
                                staticClass: "no-set-time-range",
                                on: {
                                  click: function ($event) {
                                    return _vm.chekTime("all", "restTimeRange")
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "i el-icon-time" }),
                                _c("div", { staticClass: "t" }, [
                                  _vm._v("休息开始"),
                                ]),
                                _c("div", { staticClass: "z" }, [_vm._v("至")]),
                                _c("div", { staticClass: "t" }, [
                                  _vm._v("休息结束"),
                                ]),
                              ]
                            ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c("div", { staticClass: "text" }, [_vm._v("异常规则")]),
            _c(
              "div",
              { staticClass: "form-row" },
              [
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "300px" },
                    attrs: { label: " ", "label-width": "24px" },
                  },
                  [
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.form.abnormal,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "abnormal", $$v)
                          },
                          expression: "form.abnormal",
                        },
                      },
                      [_vm._v("迟到/早退升级旷工")]
                    ),
                  ],
                  1
                ),
                _vm.form.abnormal
                  ? [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "300px" },
                          attrs: { label: "迟到/早退", prop: "halfDay" },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "50px" },
                            attrs: { maxlength: "3" },
                            on: {
                              input: (val) =>
                                (_vm.form.halfDay = val.replace(/[^\d]/g, "")),
                            },
                            model: {
                              value: _vm.form.halfDay,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "halfDay", $$v)
                              },
                              expression: "form.halfDay",
                            },
                          }),
                          _vm._v("分钟为旷工半天 "),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "300px" },
                          attrs: { label: "迟到/早退", prop: "oneDay" },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "50px" },
                            attrs: { maxlength: "3" },
                            on: {
                              input: (val) =>
                                (_vm.form.oneDay = val.replace(/[^\d]/g, "")),
                            },
                            model: {
                              value: _vm.form.oneDay,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "oneDay", $$v)
                              },
                              expression: "form.oneDay",
                            },
                          }),
                          _vm._v("分钟为旷工一天 "),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "footer",
            class: [_vm.isCollapsed ? "footer-collapsed" : ""],
          },
          [
            _c(
              "el-button",
              { attrs: { type: "info", plain: "" }, on: { click: _vm.back } },
              [_vm._v("返回")]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary", plain: "" },
                on: { click: _vm.reset },
              },
              [_vm._v("重置")]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary", loading: _vm.btnSave },
                on: { click: _vm.save },
              },
              [_vm._v("保存")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }